import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Admin from "@/components/invogue/Admin";
import Navbar from "@/components/invogue/Navbar";
import Hero from "@/components/invogue/Hero";
import TrustStrip from "@/components/invogue/TrustStrip";
import Concept from "@/components/invogue/Concept";
import Services from "@/components/invogue/Services";
import RequestDesk from "@/components/invogue/RequestDesk";
import SplitSection from "@/components/invogue/SplitSection";
import Aviation from "@/components/invogue/Aviation";
import TravelDesk from "@/components/invogue/TravelDesk";
import WhyInvogue from "@/components/invogue/WhyInvogue";
import Testimonials from "@/components/invogue/Testimonials";
import Network from "@/components/invogue/Network";
import RequestTypes from "@/components/invogue/RequestTypes";
import FinalCTA from "@/components/invogue/FinalCTA";
import Footer from "@/components/invogue/Footer";
import { IMAGES } from "@/data/content";

function Site() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-ink font-sans text-ivory" data-testid="invogue-app">
      <div className="grain" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <TrustStrip />
        <Concept />
        <SplitSection
          id="residence"
          chapter="02"
          label="Residence & Property"
          featured
          lines={["VOTRE RÉSIDENCE.", "NOTRE RESPONSABILITÉ."]}
          accentLine={1}
          body={[
            "Une résidence génère un nombre infini de besoins — souvent imprévus, fragmentés ou chronophages à coordonner.",
            "INVOGUE trouve les bons professionnels et les bonnes solutions pour la maintenance, les espaces extérieurs, les interventions techniques, les services à domicile, la recherche de biens et toutes les demandes liées à votre propriété.",
            "Un interlocuteur. Des prestataires sélectionnés. Une coordination centralisée — de l'intervention urgente à la recherche immobilière.",
          ]}
          tags={["Ménage & housekeeping", "Jardin & espaces verts", "Maintenance", "Interventions techniques", "Artisans de confiance", "Recherche immobilière", "Remise en état", "Demandes urgentes", "Remplacement de prestataire"]}
          note="INVOGUE n'est ni une entreprise de ménage, ni un jardinier, ni un gestionnaire de bien. Nous sourçons et coordonnons la bonne solution."
          cta="Confier une demande"
          image={IMAGES.residenceFeature}
          imageAlt="Résidence contemporaine éclairée à la tombée de la nuit"
        />
        <SplitSection
          id="corporate"
          chapter="03"
          label="Corporate"
          reverse
          dark
          lines={["VOTRE ENTREPRISE.", "ON S'EN OCCUPE."]}
          accentLine={1}
          body={[
            "Vos équipes doivent se concentrer sur le business — pas sur la recherche de prestataires.",
            "INVOGUE centralise les demandes opérationnelles, logistiques et de services qui demandent du temps, de la recherche ou de la coordination. De la recherche d'un fournisseur à l'organisation d'un hébergement, d'un déplacement, d'une flotte de véhicules ou d'un événement : une demande, un interlocuteur.",
          ]}
          tags={["Fournisseurs", "Hôtels", "Voyages d'affaires", "Traiteurs", "Événements", "Chauffeurs", "Flotte & véhicules", "Logistique", "Cadeaux d'affaires", "Demandes urgentes"]}
          cta="Déléguer une demande"
          image={IMAGES.desk}
          imageAlt="Environnement de travail exécutif feutré"
        />
        <SplitSection
          id="prive"
          chapter="04"
          label="Private"
          lines={["VOTRE TEMPS", "MÉRITE MIEUX."]}
          accentLine={1}
          body={[
            "Demandes personnelles, résidence, réservations, événements privés, expériences, achats, sourcing automobile ou problème imprévu — votre bureau privé externe s'en charge.",
            "Vous nous adressez la demande. Nous trouvons la solution.",
          ]}
          tags={["Demandes personnelles", "Résidence & household", "Recherche & sourcing", "Automobile", "Réservations", "Événements privés", "Expériences", "Voyages", "Dernière minute"]}
          cta="Conciergerie privée"
          image={IMAGES.hotelDusk}
          imageAlt="Hôtel élégant à la tombée du soir"
        />
        <Services />
        <RequestDesk />
        <TravelDesk />
        <Aviation />
        <WhyInvogue />
        <Testimonials />
        <section id="network">
          <Network />
        </section>
        <RequestTypes />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Site />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
